import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

interface Props {
  text: string;
  active?: boolean;
  onClick?: () => void;
}

const StyledChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  borderRadius: 100,
  height: 'auto',
  padding: '6px 16px',
  cursor: 'pointer',
  ...(active
    ? {
        backgroundColor: theme.palette.brand.darkGreen,
        color: theme.palette.neutrals.beige1,
        border: 'none',
      }
    : {
        backgroundColor: 'transparent',
        color: theme.palette.brand.darkGreen,
        border: `1px solid ${theme.palette.neutrals.beige4}`,
      }),
  '& .MuiChip-label': {
    ...theme.typography.body1R,
    fontSize: theme.typography.body1B.fontSize,
    padding: 0,
  },
}));

export default function Tag({ text, active, onClick }: Props) {
  return <StyledChip label={text} active={active} onClick={onClick} variant={active ? 'filled' : 'outlined'} />;
}
